<template>
  <div class="document">
    <h1 class="document-title">
      Clear Mortgage Capital Credit Report Authorization (Pre-Qual Check)
    </h1>

    <div class="document-rules">
      <ul>
        <li>
          <b>Purpose:</b> I understand that Clear Mortgage Capital, Inc. (CMC) intends to use the consumer
          credit report for the purpose of evaluating my credit in order to determine if I might be qualified to obtain
          credit.
        </li>
        <li>
          <b>Privacy:</b> I understand that my personal information will not be shared with any outside parties.
        </li>
        <li>
          <b>Alternative:</b> I understand that the alternative to pulling my report through CMC is to access
          my report through <a href="https://www.annualcreditreport.com/" target="_blank">www.annualcreditreport.com</a>.
          The report accessed through this site will not be associated with obtaining scores from
          <a href="https://www.annualcreditreport.com/" target="_blank">www.annualcreditreport.com</a>.
        </li>
        <li>
          <b>Follow-up:</b> I understand that I may choose to authorize CMC to pull a follow-up hard credit
          check after the date of this authorization, and that this may negatively affect my credit score at this time.
        </li>
      </ul>
    </div>

    <div class="document-info">
      <p>
        By signing below, I authorize Clear Mortgage Capital to obtain a consumer credit report
        for myself and/or my spouse
      </p>
      <div class="row mb-3">
        <div class="col-12 document-info-personal">
          <h2 id="fieldName">{{ docsData.firstName }} {{ docsData.lastName }}}</h2>
          <label for="fieldName">Participant name</label>
        </div>
        <div class="col-12 mt-3 document-info-personal">
          <h2 id="fieldDate">{{ docsData.documentSignedOn ? formatDate(docsData.documentSignedOn) : null }}</h2>
          <label for="fieldDate">Date</label>
        </div>
        <div class="col-12 mt-3 document-info-personal">
          <h2 id="fieldAddress">{{ docsData.address }}</h2>
          <label for="fieldAddress">Address</label>
        </div>
        <div class="col-12 mt-3 document-info-personal">
          <h2 id="fieldCityStateZip">{{ docsData.city }}, {{ docsData.state }} {{ docsData.zip }}</h2>
          <label for="fieldCityStateZip">City, State, ZIP</label>
        </div>
        <div class="col-12 mt-3 mb-5 document-info-personal">
          <h2 id="fieldSignature" class="d-flex justify-content-between">
            <span>{{ docsData.signature }}</span>
            <button class="btn btn-control" @click="$emit('editSignature')">
              <img src="@/assets/icons/icon-edit-normal.svg" alt="">
            </button>
          </h2>
          <label for="fieldSignature">Participant Signature</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditAuthMobilePreview',
  props: {
    docsData: Object
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&display=swap');
@page {
  margin: 0;
  padding: 0;
}
.document {
  padding-top: 80px;
  &-title {
    text-align: center;
    color: #007090;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 30px;
    padding: 15px 35px 0 35px;
    margin: 0 0 24px 0;
  }
  &-rules {
    padding: 0 24px;
    margin-bottom: 50px;

    ul {
      li {
        margin-bottom: 18px;
        color: #000000;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        font-weight: normal;
        b {
          font-weight: 500;
        }
        a {
          color: #27a2c7;
        }
      }
    }
  }
  &-info {
    padding: 0 24px;
    p {
      margin-bottom: 36px;
      color: #000000;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 20px;
    }
    &-personal {
      h2 {
        position: relative;
        font-family: 'Courier Prime', monospace;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 22px;
        min-height: 22px;
        &:after {
          position: absolute;
          left: 0;
          bottom: -7.5px;
          content: '';
          height: 1px;
          width: 100%;
          background: black;
        }
      }
      label {
        color: #000000;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: 2.5px;
      }
    }
  }
}

#fieldSignature {
  margin-top: -10px;
  color: #000000;
  font-family: "Safiar Signature";
  font-size: 36px;
  letter-spacing: 0;
  line-height: 32px;
  min-height: 32px;
  span {
    color: #000000;
    font-family: "Safiar Signature";
    font-size: 36px;
    letter-spacing: 0;
    line-height: 32px;
    min-height: 32px;
  }
}
</style>
